"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltNames = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
function AltNames({ title, subtitle, names, className, onClose, }) {
    const ref = (0, react_1.useRef)(null);
    (0, ui_1.useOutsideClick)(ref, onClose);
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: ref, className: className, "data-e2e": 'AltNames_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'AltNames_Title', children: title }), (0, jsx_runtime_1.jsx)(SubTitle, { "data-e2e": 'AltNames_SubTitle', children: subtitle }), (0, jsx_runtime_1.jsx)(AltNameTitle, { "data-e2e": 'AltNames_AltNameTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.altNames) }), (0, jsx_runtime_1.jsx)(Names, { "data-e2e": 'AltNames_Names', children: names.map((name, index) => {
                    return (0, jsx_runtime_1.jsx)(AltNamesItem, { "data-e2e": 'AltNames_AltNamesItem', children: name }, index);
                }) }), (0, jsx_runtime_1.jsx)(StyledCloseButton, { onClick: onClose, "data-e2e": 'AltNames_StyledCloseButton' })] }));
}
exports.AltNames = AltNames;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  box-sizing: border-box;

  padding: 10px;

  background: ${({ theme }) => theme.backgroundWithOpacity};
  box-shadow: ${({ theme }) => theme.infoBox.altNamesPopupShadow};
`;
const Title = styled_components_1.default.div `
  color: ${({ theme }) => theme.text};

  font-weight: bold;
  font-size: 23px;

  user-select: text;
`;
const SubTitle = styled_components_1.default.div `
  color: ${({ theme }) => theme.text};

  font-size: 14px;

  letter-spacing: -0.2px;

  user-select: text;
`;
const AltNameTitle = styled_components_1.default.div `
  margin-top: 10px;

  font-size: 14px;
  text-transform: uppercase;

  opacity: 0.6;

  user-select: text;
`;
const Names = styled_components_1.default.ul `
  margin-bottom: 10px;
  padding: 0;

  font-size: 14px;

  list-style: none;
`;
const AltNamesItem = styled_components_1.default.li `
  margin: 0 0 8px 0;

  user-select: text;

  &:before {
    padding-right: 8px;

    color: ${props => props.theme.text};

    font-size: 30px;
    line-height: 0;
    vertical-align: sub;

    content: '•';
  }
`;
const StyledCloseButton = (0, styled_components_1.default)(ui_1.CloseButton) `
  position: absolute;

  right: 0;
  bottom: 0;

  width: 30px;
  height: 30px;

  color: ${props => props.theme.text};

  svg {
    padding: 5px;
  }
`;
